import {
  MAlert,
  MButton,
  MFlex,
  MText,
} from '../../../../../components/Monetize';
import { CrmConnectionHealth } from '../useCrmConnectionHealth';

interface CrmConnectionHealthAlertProps {
  crmLabel: string;
  health: CrmConnectionHealth;
  onReAuthenticate: () => void;
}

export const CrmConnectionHealthAlert = ({
  crmLabel,
  health,
  onReAuthenticate,
}: CrmConnectionHealthAlertProps) => {
  if (health.status === 'unknown') {
    return (
      <MAlert type="warning">
        <MText>
          We couldn't check the status of your {crmLabel} connection. If data
          isn't syncing, re-authenticate the connection or contact support.
        </MText>
      </MAlert>
    );
  }

  if (health.status !== 'unhealthy') {
    return null;
  }

  return (
    <MAlert type="warning" title={`${crmLabel} connection needs attention`}>
      <MFlex direction="column" align="flex-start" gap={2}>
        <MText>
          MonetizeNow can't connect to {crmLabel}. Data won't sync between{' '}
          {crmLabel} and MonetizeNow until you re-authenticate the connection.
        </MText>
        {health.errorDescription && (
          <MText fontSize="sm" color="fg.muted">
            {crmLabel} error: {health.errorDescription}
          </MText>
        )}
        <MButton
          variant="secondary"
          size="sm"
          onClick={onReAuthenticate}
          data-testid="crm-health-reauthenticate-btn"
        >
          Re-Authenticate
        </MButton>
      </MFlex>
    </MAlert>
  );
};
